import api from "./client";

export const dashboardAPI = {
  getSummary: async ({ clientId, days = 7, agentId } = {}) => {
    return api.get("/api/v1/dashboard/summary", {
      params: { client_id: clientId, days, agent_id: agentId || undefined },
    });
  },

  getMetricBreaches: async ({ clientId, metricKey, threshold, days = 7, agentId } = {}) => {
    return api.get("/api/v1/dashboard/metric_breaches", {
      params: { client_id: clientId, metric_key: metricKey, threshold, days, agent_id: agentId || undefined },
    });
  },
};
